module.exports = __webpack_public_path__ + "img/0603-p.69ee4167.svg";